import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostPresentSuccess = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_SUCCESS_PRESENT
            });
            dispatch(Action.SetGetPresentList({
                page: 1,
                rowsPerPage: 10,
                search: ''
            }));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostPresentSuccess as SetPostPresentSuccess
}